[
  "AM4",
  "AM5",
  "LGA1200",
  "LGA1700",
  "LGA1851",
  "TR5",
  "sTR5",
  "LGA1151",
  "SP5"
]
